"use client";

import React, { useState, useEffect } from "react";
import { Box, Container, useMediaQuery, useTheme } from "@mui/material";
import LogoLoop from "../components/LogoLoop/LogoLoop";
import "../app/globals.css";
import { IMAGES } from "../constants/images";
import i18n from "../i18n";

const LeapPageLogoCarousel = () => {
  const [currentLang, setCurrentLang] = useState("en");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setCurrentLang(i18n.language || "en");
    const handleLangChange = (lang) => setCurrentLang(lang);
    i18n.on("languageChanged", handleLangChange);
    return () => i18n.off("languageChanged", handleLangChange);
  }, []);

  const isRTL = currentLang === "ar";

  const imageLogos = [
    { src: IMAGES.ADS_LOGO_C1, alt: "Top recruiting software trusted by 500+ companies worldwide" },
    { src: IMAGES.ADS_LOGO_C2, alt: "Top recruiting software trusted by 500+ companies worldwide" },
    { src: IMAGES.ADS_LOGO_C3, alt: "Top recruiting software trusted by 500+ companies worldwide" },
    { src: IMAGES.ADS_LOGO_C4, alt: "Top recruiting software trusted by 500+ companies worldwide" },
    { src: IMAGES.ADS_LOGO_C5, alt: "Top recruiting software trusted by 500+ companies worldwide" },
    { src: IMAGES.ADS_LOGO_C6, alt: "Top recruiting software trusted by 500+ companies worldwide" },
    { src: IMAGES.ADS_LOGO_C7, alt: "Top recruiting software trusted by 500+ companies worldwide" },
    { src: IMAGES.ADS_LOGO_C8, alt: "Top recruiting software trusted by 500+ companies worldwide" },
    { src: IMAGES.ADS_LOGO_C9, alt: "Top recruiting software trusted by 500+ companies worldwide" },
  ];

  return (
    <Container
      maxWidth="xl"
      sx={{
        mt: { xs: "15%", sm: "3%", md: "2.5%", lg: "4%" },
        direction: "ltr",
      }}
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
          overflow: "hidden",
          height: { xs: "70px", sm: "80px", md: "80px" },
          "& ul": { listStyle: "none", padding: 0, margin: 0 },
          "& li": { listStyle: "none" },

          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            width: "120px",
            height: "100%",
            background: "linear-gradient(to right, #000008, transparent)",
            zIndex: 2,
            pointerEvents: "none",
          },

          "&::after": {
            content: '""',
            position: "absolute",
            right: 0,
            top: 0,
            width: "120px",
            height: "100%",
            background: "linear-gradient(to left, #000008, transparent)",
            zIndex: 2,
            pointerEvents: "none",
          },
        }}
      >
        <LogoLoop
          logos={imageLogos}
          speed={100}
          direction={isRTL ? "right" : "left"}
          logoHeight={isMobile ? 40 : 50}
          gap={70}
          pauseOnHover
          scaleOnHover
          fadeOut={false}
          ariaLabel="Social Media Posts"
          style={{ background: "transparent" }}
        />
      </Box>
    </Container>
  );
};

export default LeapPageLogoCarousel;